import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    Name: '',
    email: '',
    Message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const scriptURL = 'https://script.google.com/macros/s/AKfycbw6FX-jUejvEPVxFkzCCW7SMJRj1zccnSYwQGFi-ovY7QnAX4T-X51sTj5qldy9YYcf/exec';
      const response = await fetch(scriptURL, { 
        method: 'POST', 
        body: new FormData(e.target)
      });

      if (response.ok) {
        // Success handling
        // For example, show a success message
        const msg = document.getElementById("msg");
        msg.innerHTML = "Message Sent Successfully";
        setTimeout(function(){
          msg.innerHTML = "loading..";
        }, 5000);
        e.target.reset(); // Reset the form
      } else {
        // Handle error if the response is not OK
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error.message);
      // Handle error if form submission fails
    }
  };

  return (
    <div id="contact">
      {/* ... rest of your JSX */}
      
      <div className='row'>
      <div class="contact-left">
                    <h1 class="subtitle">Contact Me</h1>
                    <p><i class="fa-solid fa-paper-plane"></i>shumaimkiyani@gmail.com</p>
                    <p><i class="fa-solid fa-phone"></i>03150110660</p>
                    <div class="social-icons">
                        <a href=""><i class="fa-brands fa-instagram"></i></a>
                        <a href=""><i class="fa-brands fa-linkedin"></i></a>
                    </div>
                    <a href="images/Shumaim's Resume.pdf" download class="btn btn2">Download CV</a>
      </div>
      <div className="contact-right">
        <form onSubmit={handleSubmit} name="submit-to-google-sheet">
        <input
            type="text"
            name="Name"
            placeholder="Name"
            onChange={handleChange}
          />
          <br />
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
          />
          <br />
          <textarea
            name="Message"
            placeholder="Message"
            onChange={handleChange}
          ></textarea>
          <button type="submit" className="btn btn2">Submit</button>
        </form>
        <span id="msg"></span>
      </div>
      </div>
      <div class="copyright">
            <p>Copyright &copy; Shumaim.</p>
        </div>
    </div>
  );
};

export default Contact;
